import styled from '@emotion/styled'
import { Message as MessageType } from 'shop/components/Landing'
import { Message } from './Message'
import { Button } from '../Controls'
import BottomModal from '../Modal/BottomModal'
import { useEffect } from 'react'
import { useMediaQueries } from 'shop/hooks'
import CenterModal from '../Modal/CenterModal'

interface Props {
  messages: Array<MessageType>
  handleCloseModal: () => void
}

export const MessagesModal = ({ messages, handleCloseModal }: Props) => {
  const { isMobile } = useMediaQueries()

  useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  const modalContent = (
    <ModalContent>
      <h3>Info</h3>
      <Messages>
        {messages.map((message) => (
          <Message
            {...message}
            key={`${message.title}-${message.description}-modal-item`}
            isMessagesModal={true}
          />
        ))}
      </Messages>
      <Button onClick={handleCloseModal}>Close</Button>
    </ModalContent>
  )

  return isMobile ? (
    <BottomModal canClose={false} handleCloseModal={handleCloseModal}>
      {modalContent}
    </BottomModal>
  ) : (
    <CenterModal canClose={false} handleCloseModal={handleCloseModal}>
      {modalContent}
    </CenterModal>
  )
}

const ModalContent = styled.div(() => ({
  display: 'flex',
  flexFlow: 'column',
  gap: '16px',
  padding: '16px',

  h3: {
    display: 'inline',

    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '23.44px'
  }
}))

const Messages = styled.div(() => ({
  display: 'flex',
  flexFlow: 'column',
  gap: '16px'
}))
